export default "__VITE_ASSET__D4zFGbTf__"